import { Tooltip } from 'antd';
import { partition } from 'lodash';

import { type TDropdownAction } from 'components/DataTable/types';
import { type AtlasGqlTask, AtlasGqlWorkContainerTypeOption } from 'types/atlas-graphql';
import i18n from 'utils/i18n';

type UpdateToPrimaryProps = {
  tasks: AtlasGqlTask[];
  disabled?: boolean;
  onClick?: () => void;
};

export const UpdateToPrimary = ({
  tasks,
  disabled,
  onClick,
}: UpdateToPrimaryProps): TDropdownAction => {
  const [damageTasks, nonDamageTasks] = partition(tasks, task =>
    [
      AtlasGqlWorkContainerTypeOption.InspectTask,
      AtlasGqlWorkContainerTypeOption.RepairTask,
    ].includes(task.type.type)
  );

  return {
    content: (
      <>
        <Tooltip
          title={
            nonDamageTasks.length > 0
              ? i18n.t(
                  'workOrder.updateToPrimaryOnlyDamageTasks',
                  'Only Damage Tasks (Inspect and Repair) can be selected.'
                )
              : damageTasks.length === 1
                ? i18n.t(
                    'workOrder.updateToPrimaryTooltipSingle',
                    "The selected Task may not be showing attributes from the Damage's Primary Observation Group. Click to update Damage attributes shown in this Task."
                  )
                : damageTasks.length > 1
                  ? i18n.t('workOrder.updateToPrimaryTooltipMultiple', {
                      count: damageTasks.length,
                    })
                  : i18n.t('workOrder.updateToPrimaryNoTasks', 'No Tasks selected.')
          }
        >
          {i18n.t('workOrder.updateToPrimary', 'Update to Primary')}
        </Tooltip>
      </>
    ),
    disabled: disabled || tasks.length === 0 || nonDamageTasks.length > 0,
    onClick,
  };
};
